import React from 'react';
import { useHistory } from 'react-router-dom';
import { stores } from '../../stores';
import { Toast } from '../Toast/Toast';
import { Button } from '../Button/Button';

export function stopGhosting() {
	const wasAdmin = stores.identity.isAdministrator();
	stores.identity.stopGhosting();
	window.location.href = wasAdmin ? '/administrators' : '/accounts';
}

export function GhostingHeader() {
	return (
		<Toast
			open
			position="bottom-left"
			message={(
				<div className="flex items-center gap-4">
					<div className="flex flex-col">
						<span className="font-bold">Ghosting Mode</span>
						<span>{stores.identity.name()}</span>
					</div>
					<Button
						size="s"
						onClick={stopGhosting}
					>
						Exit
					</Button>
				</div>
			)}
			status="error"
			icon={null}
			closeable={false}
		/>
	);
}

export default GhostingHeader;
